import { RouterLink } from "../../../../../../components/router-link";

interface Props {
  posId: string;
  label: string;
}

export const PosDetailLinkCell = ({ posId, label }: Props) => {
  return (
    <RouterLink params={{ posId }} to={"/app/pos/$posId"} underline="hover">
      {label}
    </RouterLink>
  );
};
